export default "__VITE_ASSET__DQ43fa4K__"